/* KBN — Cross-Page Engagement Timer
 * --------------------------------------------------------------
 * Misst kumulativ wie lange der User auf der Site verbringt,
 * persistiert in localStorage damit Page-Navigation den Timer
 * nicht resettet. Pausiert wenn Tab im Hintergrund ist und nach
 * längerer Inaktivität (>5 min) wird die Lücke "eingefroren" und
 * nicht mitgezählt.
 *
 * Public API:
 *   window.KBNEngagement.on(ms, key)
 *     → registriert Threshold. Wenn aktuelle Engagement-Zeit das
 *       Threshold erreicht, wird ein "kbn:engagement-reached"
 *       Event auf document gefeuert mit detail { ms, key }.
 *
 *   window.KBNEngagement.getMs()
 *     → aktuelle Engagement-Zeit in ms.
 *
 *   window.KBNEngagement.reset()
 *     → Timer von 0 starten (nach Submit nicht nötig — der Popup
 *       selbst persistiert via eigenem localStorage-Flag).
 *
 * Multi-Tab-Verhalten:
 *   Beide Tabs schreiben in dieselben localStorage-Keys. Da wir
 *   Wall-Clock (Date.now - started_at - frozen_ms) statt
 *   Accumulator-Pattern verwenden, ist der Wert tab-übergreifend
 *   konsistent. Last-write-wins, kein Double-Counting.
 */
(function () {
  if (window.__KBN_ENGAGEMENT_INIT__) return;
  window.__KBN_ENGAGEMENT_INIT__ = true;

  var KEY_START = 'kbn:engagement-started-at';
  var KEY_FROZEN = 'kbn:engagement-frozen-ms';
  var KEY_LAST = 'kbn:engagement-last-pulse';

  // Wenn der Tab >5 min nicht aktiv war, die Lücke einfrieren.
  // Das verhindert dass die Engagement-Zeit explodiert wenn jemand
  // den Tab über Nacht offen lässt.
  var INACTIVITY_THRESHOLD_MS = 5 * 60 * 1000;
  var PULSE_INTERVAL_MS = 1000;

  function readInt(key, fallback) {
    var raw = localStorage.getItem(key);
    if (raw == null) return fallback;
    var n = parseInt(raw, 10);
    return isNaN(n) ? fallback : n;
  }

  function ensureStartedAt() {
    var existing = readInt(KEY_START, 0);
    if (existing > 0) return existing;
    var now = Date.now();
    try { localStorage.setItem(KEY_START, String(now)); } catch (e) {}
    return now;
  }

  function getFrozen() { return readInt(KEY_FROZEN, 0); }
  function setFrozen(ms) {
    try { localStorage.setItem(KEY_FROZEN, String(ms)); } catch (e) {}
  }
  function getLastPulse() { return readInt(KEY_LAST, ensureStartedAt()); }
  function setLastPulse(t) {
    try { localStorage.setItem(KEY_LAST, String(t)); } catch (e) {}
  }

  function getEngagementMs() {
    var startedAt = ensureStartedAt();
    var frozen = getFrozen();
    var elapsed = Date.now() - startedAt - frozen;
    return elapsed < 0 ? 0 : elapsed;
  }

  function pulse() {
    if (document.hidden) return;
    var now = Date.now();
    var last = getLastPulse();
    var gap = now - last;
    if (gap > INACTIVITY_THRESHOLD_MS) {
      // User war inaktiv (Tab im Hintergrund, Computer im Sleep,
      // andere Tabs aktiv) — die Lücke nicht mitzählen.
      setFrozen(getFrozen() + gap);
    }
    setLastPulse(now);
  }

  // Registered thresholds. fired = true sobald das Event gefeuert
  // wurde, damit nicht mehrfach gefeuert wird.
  var thresholds = [];

  function checkThresholds() {
    if (thresholds.length === 0) return;
    var ms = getEngagementMs();
    for (var i = 0; i < thresholds.length; i++) {
      var t = thresholds[i];
      if (!t.fired && ms >= t.ms) {
        t.fired = true;
        document.dispatchEvent(new CustomEvent('kbn:engagement-reached', {
          detail: { ms: ms, key: t.key, threshold: t.ms }
        }));
      }
    }
  }

  // Initial-Pulse beim Page-Load — schließt die Lücke zwischen
  // letztem Pulse (auf voriger Seite oder Tab) und jetzt korrekt.
  ensureStartedAt();
  pulse();

  // Wenn Tab wieder sichtbar wird, sofort pulsen (sonst gilt die
  // unsichtbare Zeit potenziell als "aktiv" beim nächsten Tick).
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      // Last-pulse refresh ohne Frozen-Anrechnung — die Lücke war
      // hidden-Zeit, kein User-Engagement.
      var now = Date.now();
      var last = getLastPulse();
      var gap = now - last;
      // Hidden-Zeit immer einfrieren (auch wenn unter Threshold)
      if (gap > 0) setFrozen(getFrozen() + gap);
      setLastPulse(now);
    }
  });

  // Beim Unload (Page-Wechsel) den letzten Pulse setzen damit der
  // nächste Page-Load die Gap korrekt erkennt.
  window.addEventListener('pagehide', function () {
    setLastPulse(Date.now());
  });

  setInterval(function () {
    pulse();
    checkThresholds();
  }, PULSE_INTERVAL_MS);

  window.KBNEngagement = {
    on: function (ms, key) {
      // Wenn schon registriert mit gleichem Key → ersetzen
      thresholds = thresholds.filter(function (t) { return t.key !== key; });
      thresholds.push({
        ms: ms,
        key: key,
        fired: false
      });
      // Sofort prüfen — z.B. wenn Threshold = 30s und User schon
      // 45s auf der Site, soll das Event sofort feuern.
      checkThresholds();
    },
    off: function (key) {
      thresholds = thresholds.filter(function (t) { return t.key !== key; });
    },
    getMs: getEngagementMs,
    reset: function () {
      try {
        localStorage.removeItem(KEY_START);
        localStorage.removeItem(KEY_FROZEN);
        localStorage.removeItem(KEY_LAST);
      } catch (e) {}
      thresholds.forEach(function (t) { t.fired = false; });
      ensureStartedAt();
    }
  };
})();
